<script setup>
import { onMounted, onUnmounted } from 'vue'
import { t } from '../lib/i18n'
import Icon from './Icon.vue'

defineProps({
  title: { type: String, default: '' },
})
const emit = defineEmits(['close'])

function onKey(event) {
  if (event.key === 'Escape') emit('close')
}

onMounted(() => {
  document.addEventListener('keydown', onKey)
  document.body.style.overflow = 'hidden'
})
onUnmounted(() => {
  document.removeEventListener('keydown', onKey)
  document.body.style.overflow = ''
})
</script>

<template>
  <div class="modal-backdrop" @click.self="emit('close')">
    <div class="modal animate-in" role="dialog" aria-modal="true">
      <div class="row-between" style="margin-bottom: 16px">
        <h2>{{ title }}</h2>
        <button class="icon-btn" :aria-label="t('Lukk')" @click="emit('close')">
          <Icon name="close" />
        </button>
      </div>
      <slot />
    </div>
  </div>
</template>
